import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";

const PrivateRouteWithLayout = (props) => {
  const { layout: Layout, component: Component, ...rest } = props;

  if (!localStorage.getItem("user")) {
    localStorage.clear();
  }
  if (
    !localStorage.getItem("token") ||
    localStorage.getItem("token") === undefined
  ) {
    return <Redirect to="/login"></Redirect>;
  }
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

PrivateRouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
};

export default PrivateRouteWithLayout;
